export const DATA_LIMIT = 10;

export const PINTEREST_PIN_SYNC_FIELDS_LIST: any = [
    {
        attribute: "id",
        label: "Id",
        cssClass: 'w-48',
    },
    {
        attribute: "type",
        label: "Type",
        cssClass: 'w-48',
    },
    {
        attribute: "status",
        label: "Status",
        cssClass: 'w-24',
    },
    {
        attribute: "total",
        label: "Total",
        cssClass: 'w-24',
    },
    {
        attribute: "totalVariants",
        label: "Total Variants",
        cssClass: 'w-24',
    },
    {
        attribute: "complete",
        label: "Completed",
        cssClass: 'w-24',
    },
    {
        attribute: "inComplete",
        label: "Incompleted",
        cssClass: 'w-24',
    },
    {
        attribute: "createdAt",
        label: "Created At",
        cssClass: 'w-48',
        isDate: true
    },
    {
        attribute: "updatedAt",
        label: "Updated At",
        cssClass: 'w-48',
        isDate: true
    },
];


export const PINTEREST_PIN_SYNC_INPUT_FIELDS: any = [
    {
        attribute: "id",
        label: "Id",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "status",
        label: "Status",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "total",
        label: "Total",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "createdAt",
        label: "Created At",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "updatedAt",
        label: "Updated At",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
];


export const PINTEREST_PIN_BULK_UPLOAD_CSV_HEADER: any = [
    {label: 'Title', key: 'title'},
    {label: 'Media URL', key: 'mediaUrl'},
    {label: 'Pinterest board', key: 'board'},
    {label: 'Thumbnail', key: 'city'},
    {label: 'Description', key: 'description'},
    {label: 'Link', key: 'link'},
    {label: 'Publish date', key: 'publishDate'},
    {label: 'Keywords', key: 'keywords'},
];
